import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const API_BASE = API;

export function hlsProxy(src, ua, ref) {
  let u = `${API}/stream/m3u8?src=${encodeURIComponent(src)}`;
  if (ua) u += `&ua=${encodeURIComponent(ua)}`;
  if (ref) u += `&ref=${encodeURIComponent(ref)}`;
  return u;
}

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const CURRENCY_SYMBOLS = { ZAR: "R", USD: "$", NGN: "₦", GHS: "₵", EUR: "€", GBP: "£", KES: "KSh" };
export const sym = (c) => CURRENCY_SYMBOLS[c] || "R";

// Format a price for display. ZAR is rendered as "R24.99"; others via Intl currency formatting.
export function fmtPrice(code, amount) {
  const n = Number(amount);
  if (!code || code === "ZAR") return `R${n.toFixed(2)}`;
  try {
    return new Intl.NumberFormat("en", {
      style: "currency", currency: code,
      maximumFractionDigits: n >= 100 ? 0 : 2,
    }).format(n);
  } catch {
    return `${code} ${n.toFixed(2)}`;
  }
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
